(function() {
    'use strict';
    
a3_cabin_reports.factory('TravelValueIncompleteReasonFactory', TravelValueIncompleteReasonFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name TravelValueIncompleteReasonFactory
    * @description 
    *   Manage  Travel Value Incomplete Reasons.
    * @ngInject
    */
function TravelValueIncompleteReasonFactory(localStorageMD5Service) {

		
		var service = {
				getReasonsFromStorage : getReasonsFromStorage,
				setReasonsToStorage : setReasonsToStorage
		};
	
        /**
         * Get all the Travel Value Incomplete Reasons full objects
         * @memberof TravelValueIncompleteReasonFactory
         * @returns {array} TravelValueIncompleteReasons
         */
		function getReasonsFromStorage() {
			var results = localStorageMD5Service.get('travelValueIncompleteReasons');
			return (results || []);
		}

        /**
         * Set all the Travel Value Incomplete Reasons
         * @memberof TravelValueIncompleteReasonFactory
         * @param {array} objects A list of TravelValueIncompleteReasons.
         */
		function setReasonsToStorage(data) {
			localStorageMD5Service.set('travelValueIncompleteReasons', data);
		}

		return service;
	}

})();